import { Button, Drawer } from "@components";
import { useEffect, useRef, useState } from "react";
import { If } from "shared/components/control-statements";
import styles from "styles/import-ifood.module.scss";

import classNames from "classnames/bind";
import { IntegrationsAPI } from "providers/IntegrationsAPI";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { SuccessIcon } from "shared/components/Icons";
const css = classNames.bind(styles);

export default function ImportIFood({ open, setOpen }) {
  const [merchantID, setMerchantID] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const confirm = () => {
    setLoading(true);
    setSuccess(true);
    setLoading(false);
  };

  const getMerchantID = async () => {
    const openDeliveryResponse =
      await IntegrationsAPI.getOpenDeliveryCredentials(
        EnvironmentStorage.getSelectedEnvironment()
      );

    const openDelivery = openDeliveryResponse.getData({});

    setMerchantID(openDelivery?.merchantId);
  };

  useEffect(() => {
    if (open) getMerchantID();
  }, [open]);

  const environment = EnvironmentStorage.getEnvironment();
  const avatar = EnvironmentStorage.getCurrentAvatar();

  return (
    <>
      <Drawer
        visible={open}
        onClose={() => {
          setOpen(false);
        }}
        title={"Importar cardápio iFood"}
        subtitle="Confirme o seu Merchant ID abaixo:"
        showBackButton={!success}
        showCloseButton
        withoutTransition
        backButton={() => {
          setOpen(false);
        }}
        footer={() => {
          return !success ? (
            <Button
              text="Confirmar e importar"
              design="primary"
              className="w-100"
              loading={loading}
              disabled={loading}
              onClick={() => {
                confirm();
              }}
            />
          ) : (
            <Button
              text="Confirmar e importar"
              design="primary"
              className="w-100"
              loading={loading}
              disabled={loading}
              onClick={() => {
                confirm();
              }}
            />
          );
        }}
      >
        <If cond={!success}>
          <div className={styles.unit}>
            <div className={styles.picture}>
              <img src={avatar} alt="" />
            </div>
            <div className="d-flex flex-column flex-1">
              <p className={styles.unitName}>{environment.name}</p>
              <span className={styles.brandName}>{merchantID}</span>
            </div>
          </div>
        </If>
        <If cond={success}>
          <div className={styles.success}>
            <div className={styles.successIcon}>
              <SuccessIcon />
            </div>
          </div>
        </If>
      </Drawer>
    </>
  );
}
